// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { type ApolloClient, ApolloProvider, type NormalizedCacheObject } from '@apollo/client';
import { loadableReady } from '@loadable/component';
import {
  App,
  type AppContextType,
  type InitialLoggedInState,
  type InitialUserState,
  LoggedInStateProvider,
  UserContextProvider,
} from '@seedplanner/shared-web';
import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router';

export function renderApp(
  appContext: AppContextType,
  apolloClient: ApolloClient<NormalizedCacheObject>,
  initialLoggedInState: InitialLoggedInState,
  initialUserState: InitialUserState,
): void {
  const app = (
    <BrowserRouter>
      <HelmetProvider context={{}}>
        <LoggedInStateProvider initialState={initialLoggedInState}>
          <UserContextProvider initialState={initialUserState}>
            <ApolloProvider client={apolloClient}>
              <App appContext={appContext} />
            </ApolloProvider>
          </UserContextProvider>
        </LoggedInStateProvider>
      </HelmetProvider>
    </BrowserRouter>
  );

  const container = document.getElementById('app');
  if (container != null) {
    void loadableReady(() => {
      hydrateRoot(container, app);
    });
  }
}
